import { type CSSProperties, type MouseEvent, useEffect, useState } from 'react';

import useToasts from '@/lib/useToast.ts';

const LOCALSTORAGE_COUNT_KEY = 'fynn-pets';

const petStyles: CSSProperties = {
  cursor: 'grab',
  userSelect: 'none',
  transformOrigin: 'center bottom',
};

// Animations etc.
const affectElement = (element: HTMLElement) => {
  const animation = [
    { transform: 'scaleY(1)' },
    { transform: 'scaleY(0.93) scaleX(1.03)', cursor: 'grabbing' },
    { transform: 'scaleY(1)' },
  ];

  const timing = {
    duration: 150,
    iterations: 1,
    composite: 'replace' as CompositeOperation,
  };

  element.animate(animation, timing);
};

const usePetFynn = () => {
  const { pushToast } = useToasts();

  // Keep state count to reduce reads and for a soft prevention from users manipulating localStorage
  const [internalCount, setInternalCount] = useState(-1);

  // Read count from localStorage
  useEffect(() => {
    const storageCount = Number.parseInt(localStorage.getItem(LOCALSTORAGE_COUNT_KEY) ?? '');
    const count = Number.isNaN(storageCount) ? 0 : storageCount;

    // It's fine, we're using localstorage
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setInternalCount(count);
  }, []);

  useEffect(() => {
    // Don't save without read first:
    if (internalCount === -1) {
      return;
    }
    localStorage.setItem(LOCALSTORAGE_COUNT_KEY, internalCount.toString());
  }, [internalCount]);

  const increasePetCount = () => {
    setInternalCount((count) => count + 1);
  };

  // TODO Change into something more exciting
  const checkMilestones = () => {
    const MILESTONES = [100, 1000, 10000, 100000, 1000000];
    const count = internalCount + 1; // Cancel out state update lag

    if (MILESTONES.includes(count)) {
      const formatter = new Intl.NumberFormat(); //  formats into more readable number e.g. "1,000,000"
      pushToast('info', `${formatter.format(count)} !`);
    }
  };

  const petFynn = (event: MouseEvent<HTMLElement>) => {
    affectElement(event.currentTarget);
    increasePetCount();
    checkMilestones();
  };

  return {
    petFynn,
    petStyles,
    petCount: internalCount,
  };
};

export default usePetFynn;
